module.exports = __webpack_public_path__ + "img/thought2.bcf3be62.png";